import React from "react";
import styled from "styled-components";
import BaseComponent from "../../BaseComponent.js";
import NanoFlex from "../../Global/NanoFlex.js";
import Type from "../../Global/Typography.js";

const StyledAboutChaseUp = styled(NanoFlex)`
  padding: 0 100px 0 100px;
  gap: 30px;

  .assessmentRecruitTopicBlock {
    width: 40%;
  }

  .assessmentRecruitContentBlock {
    gap: 24px;
    width: 60%;

    .title {
      h3 {
        font-weight: 500;
      }
    }

    .articleContent {
      gap: 16px;

      p {
        color: ${(props) => props.theme.color.primaryColors.darkPurple};
        opacity: 0.7;
      }
    }
  }
  @media only screen and (max-width: 1450px) {
    padding: 0 50px 0 50px;
  }

  /* TABLETS */
  @media only screen and (max-width: 1024px) {
    padding: 0 30px 0 30px;
  }

  @media only screen and (max-width: 815px) {
    padding: 0 10px 0 10px;
    flex-direction: column;
    gap: 16px;

    .assessmentRecruitTopicBlock {
      display: none;
    }

    .assessmentRecruitTopicBlock,
    .assessmentRecruitContentBlock {
      width: 100%;
    }
  }
`;

export default class AboutChaseUp extends BaseComponent {
  componentDidMount() {
    super.componentDidMount();
  }

  componentWillUnmount() {
    super.componentWillUnmount();
  }

  render() {
    return (
      <StyledAboutChaseUp justifyContent={"flex-start"} alignItems={"flex-start"}>
        <NanoFlex className="assessmentRecruitTopicBlock" justifyContent="flex-start" alignItems="flex-start">
          <Type.p>{this.translation.aboutUs.aboutChaseUp}</Type.p>
        </NanoFlex>
        <NanoFlex className="assessmentRecruitContentBlock" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
          <NanoFlex className="title" justifyContent="flex-start">
            <Type.h3>{this.translation.aboutUs.aboutChaseUpTitle}</Type.h3>
          </NanoFlex>
          <NanoFlex className="articleContent" flexDirection="column" justifyContent="flex-start" alignItems="flex-start">
            <Type.p>{this.translation.aboutUs.aboutChaseUpTextOne}</Type.p>
            <Type.p>{this.translation.aboutUs.aboutChaseUpTextTwo}</Type.p>
          </NanoFlex>
        </NanoFlex>
      </StyledAboutChaseUp>
    );
  }
}
